import * as R from 'ramda';
import { connect } from 'react-redux';
import { Form, message } from 'antd';
import { branch, lifecycle, mapProps, renderComponent, withHandlers, withStateHandlers } from 'recompose';

import AssignUserForm from './component';
import { handleRequestUpdateModal } from '../../redux/thunk/requests';
import { closeCurrentModal } from '../../modals';

import { fetchUsers } from '../../redux/thunk/users';
import { Spinner } from '../../components/ui-helpers';

const mapStateToProps = ({
  users: { items },
}, { payload }) => ({
  users: items,
  requestId: payload.requestId,
  responsibleUserId: payload.responsibleUserId,
});

export const AssignUserModal = Form.create()(R.compose(
  connect(
    mapStateToProps,
    {
      handleRequestUpdateModal, closeCurrentModal, fetchUsers,
    },
  ),
  withStateHandlers(
    ({ responsibleUserId }) => ({
      selectedUser: responsibleUserId,
    }),
    {
      setSelectedUser: () => value => ({
        selectedUser: value,
      }),
    },
  ),
  withHandlers({
    onSubmitForm: props => (event) => {
      event.preventDefault();
      props.form.validateFieldsAndScroll((err) => {
        if (!err) {
          const data = {
            responsibleUser: props.selectedUser,
          };
          props.handleRequestUpdateModal(props.requestId, data)
            .then(() => {
              props.closeCurrentModal();
              message.success('User successfully assigned to Request.');
            })
            .catch(() => message.error('Fail to assign user to Request.'));
        } else {
          console.error(err);
        }
      });
    },
  }),
  mapProps(({
    responsibleUserId,
    ...props
  }) => ({
    ...props,
    title: responsibleUserId ? 'Assign another person' : 'Assign person',
  })),
  lifecycle({
    componentDidMount() {
      if (!this.props.users) {
        this.props.fetchUsers();
      }
    },
  }),
  branch(
    ({ isFetching, users }) => isFetching && users.length === 0,
    renderComponent(Spinner),
  ),
)(AssignUserForm));




// WEBPACK FOOTER //
// ./src/modals/assign-user-modal/container.js